function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as s } from "./index.es33.js";
import { clsx as e } from "./index.es105.js";
import { Typography as m } from "./index.es35.js";
import "./index.es36.js";
import { createInlineStyles as c } from "./index.es583.js";
import o from "./index.es584.js";

var g = function g(_ref) {
  var p = _ref.id,
      t = _ref.title,
      r = _ref.description,
      i = _ref.tooltipRef,
      l = _ref.offset,
      a = _ref.className,
      _ref$isAbsolute = _ref.isAbsolute,
      y = _ref$isAbsolute === void 0 ? !0 : _ref$isAbsolute;
  return s.jsxs("div", {
    style: c({
      offset: l
    }),
    id: p,
    className: e(e(o.tooltip, a !== null && a !== void 0 ? a : ""), _defineProperty({}, o.tooltipAbsolute, y)),
    ref: i,
    children: [typeof t == "string" ? s.jsx(m.Body2, {
      className: o.text,
      children: t
    }) : t, typeof r == "string" ? s.jsx(m.Body2, {
      className: o.description,
      children: r
    }) : r]
  });
};

export { g as Tooltip };